import Vue from "vue"

/* 更新单选的配置显示权限和必填权限信息*/
export function updateConfig(allInfos) {
  allInfos.map((item) => {
    updateInfoConfig(item)
    if (item.templateSub) {
      item.templateSub.map((item) => {
        updateInfoConfig(item)
      })
    }
  })
}

// 更新所有区域权限
export function updateAllAreaPermissions(list) {
  updatePermissions(list)
}

/**
 * @param {*} info 改变的字段
 * @param {*} list 所有字段数据
 */
export function updateAreaPermissions(info, list) {
  updatePermissions(list)
}

/**
 * 更新区域权限
 * @param {*} infos 
 * @param {*} allInfos 
 */
function updatePermissions(allInfos) {
  var allConfig = { shows: [], requreins: [] }
  var enableConfig = { shows: [], requreins: [] }
  // 获取所有显示配置字段
  updateSingleAreaPermissions(allInfos, allConfig, enableConfig)
  allInfos.map((item) => {
    if (!item.sub) {
      return
    }
    item.sub.map((subs) => {
      updateSingleAreaPermissions(subs, {...allConfig}, {...enableConfig})
    })
    updateSingleAreaPermissions(item.templateSub, {...allConfig}, {...enableConfig})
  })
}
/**
 * 更新单个区域权限
 * @param {*} allInfos 
 */
function updateSingleAreaPermissions(allInfos, allConfig, enableConfig) {
  allInfos.map((item) => {
    addConfig(item, allConfig, enableConfig)
  })
  allInfos.map((item) => {
    if (allConfig.shows.indexOf(item.field) !== -1) {
      if (item.isOriginShow == undefined) {
        item.isOriginShow = item.isShow
      }
      item.optionShow = enableConfig.shows.indexOf(item.field) !== -1
      Vue.set(item, "isShow", item.isOriginShow && item.optionShow)
    }
    // 生效的配置，显示，否则不显示
    if (allConfig.requreins.indexOf(item.field) !== -1) {
      if (!item.isOriginRequrein) {
        item.originRequrein = item.requrein
      }
      item.optionRequrein = (enableConfig.requreins.indexOf(item.field) !== -1 ? 0 : 1)
      if (item.optionShow != undefined && !item.optionShow) {
        Vue.set(item, "requrein", false)
      } else {
        Vue.set(item, "requrein", item.optionRequrein)
      }
    }
  })
}

/**
 * 权限处理
 * @param {*} item 
 * @param {*} allConfig 
 * @param {*} enableConfig 
 */
function addConfig(item, allConfig, enableConfig) {
  if (item.config) {
    Object.keys(item.config).map((id) => {
      const value = item.config[id]
      // 必填如果有数据，才生效
      if (Array.isArray(item.value) && item.value.length > 0 && item.value[0].id) {
        allConfig.requreins.push(...value.requreins)
      }
      if (Array.isArray(item.value) && item.value.length > 0 && item.value[0].id === id) {
        enableConfig.shows.push(...value.shows)
        enableConfig.requreins.push(...value.requreins)
      }
      allConfig.shows.push(...value.shows)
    })
  }
}

function updateInfoConfig(info) {
  if (info.config) {
    return
  }
  if (parseInt(info.fieldType, 10) !== 5) {
    return
  }
  if (!(Array.isArray(info.dataArea) && info.dataArea.length > 0)) {
    return
  }
  updateSingleConfig(info)
}

/**单个配置信息 */
function updateSingleConfig(info) {
  if (info.config) {
    return
  }
  var config = {}
  info.dataArea.map((item) => {
    if (!Array.isArray(item.fieldControl)) {
      return
    }
    var data = { shows: [], requreins: [] }
    item.fieldControl.map((item) => {
      if (!item.field) {
        return
      }
      if (item.flag && parseInt(item.flag, 10) === 0) {
        data.shows.push(item.field)
      }
      if (item.requrein && parseInt(item.requrein, 10) === 0) {
        data.requreins.push(item.field)
      }
    })
    config[item.id] = data
  })
  info.config = config
}